import { render, staticRenderFns } from "./percentage-input.vue?vue&type=template&id=6d9e7073&scoped=true&"
import script from "./percentage-input.vue?vue&type=script&lang=ts&"
export * from "./percentage-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9e7073",
  null
  
)

export default component.exports